import React from "react";
import { View, Text } from "@react-pdf/renderer";
import Styles from "../Styles";

/* ---------- small helpers ---------- */
const styles = Styles();

export const LabelLineField = ({ label, width }) => (
  <View style={styles.fieldRow}>
    <Text style={{ ...styles.ButtonTextSmall, width: width || 78 }}>
      {label}
    </Text>
    <View style={styles.line} />
  </View>
);

export const DateBoxes = ({ label = "Date" }) => (
  <View style={styles.fieldRow}>
    <Text style={styles.ButtonTextSmall}>{label}</Text>
    <View style={styles.dateRow}>
      {Array.from({ length: 2 }).map((_, i) => (
        <View key={`d${i}`} style={styles.dateBox} />
      ))}
      <Text style={styles.slash}>/</Text>
      {Array.from({ length: 2 }).map((_, i) => (
        <View key={`m${i}`} style={styles.dateBox} />
      ))}
      <Text style={styles.slash}>/</Text>
      {Array.from({ length: 4 }).map((_, i) => (
        <View key={`y${i}`} style={styles.dateBox} />
      ))}
    </View>
  </View>
);

/* ---------- composed rows ---------- */

export const NameDateRow = () => (
  <View style={styles.row}>
    <View style={{ ...styles.row, gap: 0, width: "48%" }}>
      <LabelLineField label="Name" />
    </View>

    <View style={{ ...styles.row, gap: 0, width: "52%" }}>
      <DateBoxes />
    </View>
  </View>
);

export const TwoColumnLineRow = ({
  leftLabel,
  rightLabel,
  showKeyNumber = false,
  leftLines = 1,
  rightLines = 1,
}) => {
  const renderLines = (count) =>
    Array.from({ length: count }).map((_, i) => (
      <View key={i} style={styles.line} />
    ));

  return (
    <View style={styles.row}>
      <View style={styles.col}>
        <Text style={styles.ButtonTextSmall}>{leftLabel}</Text>
        {renderLines(leftLines)}
      </View>

      <View style={styles.col}>
        <Text style={styles.ButtonTextSmall}>{rightLabel}</Text>
        {renderLines(rightLines)}

        {showKeyNumber && (
          <View style={styles.fieldRow}>
            <LabelLineField label="Key Number" width={90} />
          </View>
        )}
      </View>
    </View>
  );
};

export const LabelLineRow = ({ styles, label, lines = 1, gap = 0 }) => (
  <View style={{ ...styles.fieldRow }}>
    {label && (
      <Text style={styles.ButtonTextSmall} wrap={false}>
        {label}
      </Text>
    )}

    <View style={{ flex: 1, marginBottom: 6 }}>
      {Array.from({ length: lines }).map((_, i) => (
        <View key={i} style={styles.line} />
      ))}
    </View>
  </View>
);

export const LabelLineColumn = ({ styles, label, lines = 1, height }) => (
  <View style={styles.fieldColumn}>
    <Text style={{ ...styles.ButtonTextSmall, width: "100%", marginBottom: 6 }}>
      {label}
    </Text>

    {Array.from({ length: lines }).map((_, i) => (
      <View
        key={i}
        style={{
          ...styles.lineFull,
          marginBottom: i === lines - 1 ? 0 : 6,
          height: height || "16",
        }}
      />
    ))}
  </View>
);

export const AttorneyLabelLineRow = ({ styles, label, lines = 1, gap = 0 , subLabel }) => (
  <View style={{ ...styles.fieldRow }}>
    {label && (
      <Text style={styles.LabelSmallSemiBold} wrap={false}>
        {label}
      </Text>
    )}

    <View style={{ flex: 1 }}>
      {Array.from({ length: lines }).map((_, i) => (
        <View
          key={i}
          style={{ ...styles.line, width: "15px", height: "15px", border: "1px solid gray" }}
        />
      ))}
    </View>
  </View>
);
